import HERU_API from '../shared/constants/heruApi';
import { get, post, put } from '../shared/utils/FetchSSL.util';


const getUserDeclarationStatus = async (tokenSession?: string) => {
	try {
		const response = await get(
			HERU_API.HERU_API_FLOW_APPROVE,
			{
				token: true,
				tokenSession,
				isNewGateway: true,
			},
		);
		return response;
	} catch (error) {
		throw error;
	}
};

const putUserDeclarationStatus = async (id: number, body: object, tokenSession?: string) => {
	try {
		const response = await put(HERU_API.HERU_API_FLOW_APPROVE_UPDATE(id), body, {
			token: true,
			tokenSession,
			isNewGateway: true,
		});
		return response;
	} catch (error) {
		throw error;
	}
};

const getUserDeclarationDetail = async (fftId: number, tokenSession?: string) => {
	try {
		const response = await get(HERU_API.HERU_API_FLOW_APPROVE_DETAIL(fftId), {
			token: true,
			tokenSession,
			isNewGateway: true,
		});
		return response;
	} catch (error) {
		throw error;
	}
};

const getUserDeclarationDetailFFT = async (fftId: number, tokenSession?: string) => {
	try {
		const response = await get(HERU_API.HERU_API_FLOW_APPROVE_DETAIL_FFT(fftId), {
			token: true,
			tokenSession,
			isNewGateway: true,
		});
		return response;
	} catch (error) {
		throw error;
	}
};

const checkFlowApproval = async (tokenSession?: string) => {
	try {
		const response = await get(HERU_API.HERU_API_FLOW_APPROVE_CHECK, {
			token: true,
			tokenSession,
			isNewGateway: true,
		});
		return response;
	} catch (error) {
		throw error;
	}
};

const postFlowApproval = async (body: object, tokenSession?: string) => {
	try {
		const response = await post(HERU_API.HERU_API_FLOW_APPROVE_CHECK, body, {
			token: true,
			tokenSession,
			isNewGateway: true,
		});
		return response;
	} catch (error) {
		throw error;
	}
}


export { getUserDeclarationStatus, putUserDeclarationStatus, getUserDeclarationDetail, getUserDeclarationDetailFFT, checkFlowApproval, postFlowApproval };